// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__2dO3e","copyright":"Footer_copyright__1ZK9t"};